export interface ResolvedVoiceAssistantCandidate {
    assistantId: string;
    assistantName: string;
    author?: string | null;
    favourite: boolean;
    isPinned: boolean;
    description?: string | null;
}

export interface ResolvedVoiceAssistant {
    status?: 'resolved' | 'suggestions' | 'ambiguous';
    message?: string | null;
    assistantId?: string | null;
    assistantName?: string | null;
    favourite?: boolean;
    isPinned?: boolean;
    candidates?: ResolvedVoiceAssistantCandidate[];
}

export type OpenableVoiceAssistant = ResolvedVoiceAssistant & {
    assistantId: string;
    assistantName: string;
};

export const isOpenableVoiceAssistant = (
    assistant: ResolvedVoiceAssistant
): assistant is OpenableVoiceAssistant =>
    assistant.status !== 'suggestions' &&
    assistant.status !== 'ambiguous' &&
    Boolean(assistant.assistantId) &&
    Boolean(assistant.assistantName);

export const getVoiceAssistantResolutionMessage = (
    assistant: ResolvedVoiceAssistant
): string => {
    if (assistant.message) {
        return assistant.message;
    }

    const candidates = assistant.candidates ?? [];
    if (candidates.length === 0) {
        return assistant.status === 'ambiguous'
            ? 'I found multiple matching assistants. Which one would you like? You can say the number or assistant name.'
            : 'I could not find an exact assistant match. Try rephrasing the assistant name.';
    }

    const candidateText = candidates
        .slice(0, 5)
        .map((candidate, index) => {
            const author = candidate.author
                ? `, author ${candidate.author}`
                : '';
            return `${index + 1}. ${candidate.assistantName}${author}`;
        })
        .join('; ');

    return assistant.status === 'ambiguous'
        ? `I found multiple matching assistants: ${candidateText}. Which one would you like? You can say the number or assistant name.`
        : `I could not find an exact assistant match. Did you mean: ${candidateText}?`;
};
